"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeHTMLLanguage = void 0;
var Language_1 = require("../constants/Language");
var initializeHTMLLanguage = function (monaco) {
    var customSuggestions = [
        '##logoUrl##',
        '##url##',
        '##urlToCompletePurchase##',
        '##customerFirstName##',
        '##customerLastName##',
        '##customerPhoneNumber##',
        '##customerEmail##',
        '##deliveryAddress##',
        '##deliveryCity##',
        '##deliveryState##',
        '##deliveryZipCode##',
        '##dealerName##',
        '##dealerPhoneNumber##',
        '##dealerEmail##',
        '##dealerAddress##',
        '##dealerCity##',
        '##dealerState##',
        '##dealerZip##',
        '##buildingStyle##',
        '##buildingImages##',
        '##buildingIsoImage##',
        '##buildingDimensions##',
        '##subtotal##',
        '##displayDepositDiscount##',
        '##depositAmount##',
        '##depositDiscount##',
        '##depositDue##',
        '##depositPercent##',
        '##region##',
        '##salesTaxAmount##',
        '##salesTaxPercent##',
        '##totalBuildingPrice##',
        '##additionalFields##',
        '##emailGreeting##',
        '##paymentMethod##',
        '##vendorName##',
        '##vendorAddress##',
        '##vendorCity##',
        '##vendorState##',
        '##vendorZip##',
        '##vendorEmailAddress##',
        '##vendorPhoneNumber##',
        '##notes##',
    ];
    monaco.languages.registerCompletionItemProvider(Language_1.Language.Html, {
        provideCompletionItems: function (model, position) {
            var suggestions = [];
            // Check for text like "##" to trigger suggestions
            var word = model.getWordAtPosition(position);
            if (word && word.word.startsWith('##')) {
                customSuggestions.forEach(function (suggestion) {
                    suggestions.push({
                        label: suggestion,
                        kind: monaco.languages.CompletionItemKind.Text,
                        insertText: suggestion,
                        detail: 'HTML token',
                    });
                });
            }
            return { suggestions: suggestions };
        },
    });
};
exports.initializeHTMLLanguage = initializeHTMLLanguage;
